var map = {
	"./csu.jpg": "8414",
	"./csu2.jpg": "3610",
	"./dingding.png": "4be3",
	"./futures.png": "4169",
	"./limit.png": "6dc0",
	"./logo.png": "cf05",
	"./pytorch.png": "7d79",
	"./xgq.png": "ead9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";